// frontend/src/lib/supabaseClient.js

import { createClient } from '@supabase/supabase-js';

// Récupérez vos variables d'environnement
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Créez et exportez le client Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey);